import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { AccountInfo } from '../models/account-info';


@Injectable({
  providedIn: 'root'
})
export class AccountInfoService extends BaseService<AccountInfo> {
  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string
  ) {
    super(http, rootUrl, 'AccountInfo');
  }
}
